import axios from 'axios';
import Parse from 'parse';
import { getUrl } from '../utils';
import { actionWithLoader } from './utils';
import { filterByPack, setPack } from './packs';

export const Background = Parse.Object.extend('Background');

export const getBackgroundsPerPage = (limit = 10, skip = 0, filter = '', packId) => {
  return async (dispatch) => {
    const query = new Parse.Query(Background)
      .include('pack')
      .notEqualTo('deleted', true)
      .doesNotExist('template') // TODO: remove this line when old backgrounds are removed
      .limit(limit)
      .skip(skip)
      .descending('updatedAt')
      .withCount(true);

    if (filter !== '') {
      query.contains('title', filter);
    }

    filterByPack(query, packId);

    const backgrounds = await query.find();

    dispatch({
      type: 'GET_BACKGROUNDS',
      backgrounds: backgrounds.results.map((background) => background.toJSON()),
      count: backgrounds.count,
    });
  };
};

export const countBackgrounds = async () => {
  const query = new Parse.Query(Background).notEqualTo('deleted', true).doesNotExist('template');
  return await query.count();
};

export const createBackground = (values) => {
  return actionWithLoader(async (dispatch) => {
    const newValues = { ...values };

    // #1 - Create background
    const background = new Background();
    background.set('title', newValues.title);
    background.set('description', newValues.description);

    setPack(background, newValues.pack);

    // #2 - Upload image
    if (newValues.image instanceof File) {
      const formData = new FormData();
      formData.append('file', newValues.image);
      const API_SERVER_URL = getUrl() + '/api';
      const response = await axios.post(API_SERVER_URL + '/uploadBackground', formData);
      if (response.data) {
        background.set('image', response.data.fileName);
      }
    }

    await background.save();

    // #3 - Update store
    dispatch({
      type: 'ADD_BACKGROUND',
      payload: background.toJSON(),
    });
  });
};

export const deleteBackground = (id) => {
  return actionWithLoader(async (dispatch) => {
    // #1 - Remove background in database
    const background = await new Parse.Query(Background).get(id);
    if (!background) {
      throw new Error('Background not found');
    }
    background.set('deleted', true);
    await background.save();

    // #2 - Update store
    dispatch({
      type: 'DELETE_BACKGROUND',
      id,
    });
  });
};

export const editBackground = (id) => {
  return async (dispatch) => {
    const background = await new Parse.Query(Background).include('pack').get(id);
    if (!background) {
      throw new Error('Background not found');
    }

    dispatch({
      type: 'EDIT_BACKGROUND',
      background: background.toJSON(),
    });
  };
};

export const updateBackground = (background, values) => {
  return actionWithLoader(async (dispatch) => {
    const newValues = { ...values };

    const updatedBackground = new Background();
    updatedBackground.id = background.objectId;

    updatedBackground.set('title', newValues.title);
    updatedBackground.set('description', newValues.description);

    if (newValues.image instanceof File) {
      const formData = new FormData();
      formData.append('file', newValues.image);

      const API_SERVER_URL = getUrl() + '/api';
      const response = await axios.post(API_SERVER_URL + '/uploadBackground', formData);
      if (response.data) {
        updatedBackground.set('image', response.data.fileName);
      }
    }

    setPack(updatedBackground, newValues.pack);

    await updatedBackground.save();

    dispatch({
      type: 'UPDATE_BACKGROUND',
      background: updatedBackground.toJSON(),
    });
  });
};

export const reorderBackgrounds = (values) => {
  return async (dispatch) => {
    const promises = values.map((o, index) => {
      const bg = new Background();
      bg.id = o.objectId;
      bg.set('order', index);
      return bg.save();
    });
    const bgs = await Promise.all(promises);

    dispatch({
      type: 'REORDER_BACKGROUNDS',
      backgrounds: bgs.map((o) => o.toJSON()),
    });
  };
};
